import { createContext, useState } from 'react';

import { ChildrenProps, HeaderContextData } from 'types';

interface HeaderContextProps {
  state: HeaderContextData;
  setState: (data: HeaderContextData) => void;
}

export const HeaderContext = createContext<HeaderContextProps>({
  state: {},
  setState: () => {},
});

export const HeaderProvider = ({ children }: ChildrenProps<any>) => {
  const [state, setState] = useState<HeaderContextData>({});

  return (
    <HeaderContext.Provider value={{ state, setState }}>
      {children}
    </HeaderContext.Provider>
  );
};
